import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import CiamModule from 'ciam-modules';
import 'ciam-modules/style.css';
import PropTypes from 'prop-types';
import authHelper from 'helpers/authHelper';
import { getCIAMEnviroment } from '../helpers';
import useUserCapability from 'sharedHooks/useUserCapability';
import { AssetGroupApi } from 'api';
import { useQueryParams } from 'sharedHooks/useQuery';
import { formatDate } from 'helpers/dateTimeFormatter';

const AssetManagementComponent = (props) => {
    const accessToken = authHelper.getAccessToken();
    const {
        selectedLanguage,
        selectedOrganization = {},
        environmentStageSelector
    } = props.model;
    const [ciamEnv, setCiamEnv] = useState(null);
    const ciamErrorHandler = (error) => {
        console.log('error', error);
    };
    const userCapabilityHelper = useUserCapability();

    const importAssetGroupToLocationGroup = (assetGroupId) => {
        return AssetGroupApi.importToLocation(assetGroupId);
    };

    useEffect(() => {
        if (environmentStageSelector) {
            const reqCIAMEnv = getCIAMEnviroment(environmentStageSelector);
            setCiamEnv(reqCIAMEnv);
        }
    }, [environmentStageSelector]);


    const { organizationID } = selectedOrganization;
    const isRECUser = userCapabilityHelper?.hasHomePageRecCapability?.() || false; /* FALSE FOR LSU AND END USER | TRUE FOR REC USER */
    const hasImportAssetGroupToLocation = userCapabilityHelper?.hasImportAssetGroupToLocation?.() || false; /*TRUE FOR REC, Country Admin, Principal & PT_DEV */
    const history = useHistory();
    const { fleetId } = useQueryParams();
    // Capture once on mount so the key/props don't change when the URL is cleared
    const [initialFleetId] = useState(fleetId || null);

    // Immediately strip the query params from the URL after they've been consumed
    useEffect(() => {
        if (fleetId) {
            history.replace(history.location.pathname);
        }
    }, []);

    return organizationID && ciamEnv &&
        <div className='asset-management-wrapper'>
            <CiamModule
                key={`${organizationID}-${initialFleetId || ''}`}
                orgId={organizationID}
                lang={selectedLanguage || 'en'}
                module={'asset'}
                environment={ciamEnv}
                headerHeight={10}
                token={accessToken}
                errorCb={ciamErrorHandler}
                isRECUser={isRECUser}
                hasImportAssetGroupToLocation={hasImportAssetGroupToLocation} // update key and also update ciam module to use hasImportAssetGroupToLocation for showing import button in asset group details page
                importAssetGroupToLocationGroup={importAssetGroupToLocationGroup}
                initialFleetId={initialFleetId}
                formatDateLocale={formatDate}
            />
        </div>
        ;
};

AssetManagementComponent.propTypes = {
    model: PropTypes.shape({
        selectedLanguage: PropTypes.string,
        selectedOrganization: PropTypes.object,
        environmentStageSelector: PropTypes.string
    })
};

export default AssetManagementComponent;
